module.exports = __webpack_public_path__ + "img/lv18.047bbc21.png";